import { FC } from 'react'
import ShopInfoTemplate from 'components/Templates/ShopInfoTemplate'

const RegisterShop: FC = () => {
  return <ShopInfoTemplate isRegister />
}

export default RegisterShop
